<template>
  <!-- <b-container> -->
    <b-row>
      <b-col class="requestCol-saml">
        <b-row class="mb-3">
          <b-col class="" md="12">
            <h6 >Name</h6>
          </b-col>
          <b-col class="" md="12">
            <b-form-textarea class="overflow-auto" id="textarea" v-model="selectedSamlGroup.name" style="height: 40px"
                             placeholder="SAML Group mapping name..." rows="2" max-rows="6"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="" md="12">
            <h6 >Description</h6>
          </b-col>
          <b-col class="" md="12">
            <b-form-textarea class="overflow-auto" id="textarea" v-model="selectedSamlGroup.description"
                             placeholder="Description..." rows="4" max-rows="6"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <h6 >Roles</h6>
          </b-col>
          <b-col md="12">
            <div>
              <multiselect v-model="selectedSamlGroup.roles" :options="roles ? roles : []" :searchable="false"
                           :close-on-select="false" :multiple="true" :clear-on-select="false" :preserve-search="true"
                           placeholder="Pick some" :preselect-first="true"></multiselect>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <h6 >Preferred Task Type Filter</h6>
          </b-col>
          <b-col md="12">
            <div>
              <multiselect v-model="selectedSamlGroup.pref_vn_fltr" :options="taskStatus ? taskStatus : []"
                           :searchable="false" :close-on-select="false" :multiple="true" :clear-on-select="false"
                           :preserve-search="true" placeholder="Pick some" :preselect-first="true"></multiselect>
            </div>
          </b-col>
        </b-row>
        <div class="facilitiesWrapper">
          <div class="">
            <div class="facilityDetails">
              <div class="col-sm-6 p-0 right ">
                <div class="headerpart">
                  <div class="pull-left col-sm-6">Facilities</div>
                  <div class="col-sm-2 text-center p-0">Sensors</div>
                  <div class="col-sm-2 text-center p-0">Access</div>
                  <div class="col-sm-2 text-center p-0">Alerts</div>
                </div>
                <div class="facilityListWrap facilityWrapLeft">
                  <div class="facilitiesList" v-for="location in locations" :key="location.locationId"
                       @click="onSelectedRow(location)">
                    <div class="facilityListName pull-left col-sm-6">
                      {{ location.name }}
                    </div>
                    <div class="col-sm-2 text-center">
                      {{ location.roomCount }}
                    </div>
                    <div class="col-sm-2 text-center access">
                      {{ location.roomAccessCount }}
                    </div>
                    <div class="col-sm-2 text-center alerts">
                      {{ location.roomAlertCount }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 p-0 right">
                <div class="headerpart"></div>
                <div class="facilityListWrap facilityWrapLeft col-sm-12 mt-1">
                  <TreeItem v-for="child in selectedFacility.children" :item="child" :key="child.id"
                            :selectedFacility="selectedFacility" :selectedSamlGroup="selectedSamlGroup" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="align-self: end">
          <div class="importBtn" style="
              width: fit-content;
              align-self: flex-end;
              margin: 15px 15px 0 0;
              color: white;
            " @click="$emit('closeEvent')">
            Close
          </div>
          <div class="importBtn" style="
              width: fit-content;
              align-self: flex-end;
              margin: 15px 15px 0 0;
              color: white;
            " @click="saveSAMLGroupMapping()">
            Save
          </div>
        </div>
      </b-col>
    </b-row>
  <!-- </b-container> -->
</template>
<script>
import TreeItem from "./TreeItem.vue";
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Multiselect from "vue-multiselect";

Vue.use(VueToast);
Vue.component("multiselect", Multiselect);

export default {
  name: "TreeView",
  components: { TreeItem, Multiselect },
  props: {
    lastSelectedTenant: "",
    selectedSamlGroup: {}
  },
  data() {
    return {
      locations: [],
      name: "",
      description: "",
      roles: "",
      isExpanded: false,
      selectedFacility: {},
      lastSelectedRole: "",
      node: "",
      allFacilitiesLength: 0,
      globalAccessUser: false,
      globalAccess: false,
      globalAlert: false,
      taskStatus: [],
      user: "",
      parentNodes: [],
      location: "",
      modalShow: true,
      isImportingUserOperation: false,
      importedUsers: [],
      importLoadingMessage: ""
    };
  },
  mounted() {
    this.getLocation();
    this.fetchRoles();
    this.fetchTaskTypes();
  },
  methods: {
    async fetchRoles() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.IDENTITY_MANGER + `/tenants/${this.lastSelectedTenant}/roles`;
      var fetch_Roles = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(fetch_Roles);
        if (response.status === 503) {
          return this.fetchRoles();
        }
        var roles_fetch = await response.json();
        var roles = this.json2array(roles_fetch);
        if (roles && roles.length > 0) {
          roles = this.sortArrayByKey(roles, "name");
          this.roles = roles.map((r) => r.name);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchTaskTypes() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.CAREAI_VIRTUAL +
        `/tenants/${this.lastSelectedTenant}/taskTypes?isActive="false"`;
      var tenant_task_status = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantstatus = await fetch(tenant_task_status);
        if (tenantstatus.status == 503) {
          return this.fetchTaskTypes();
        }
        var response = await tenantstatus.json();
        response.taskTypes.forEach((e) => this.taskStatus.push(e.name));
      } catch (error) {
        console.error(error);
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    json2array(json) {
      var result = [];
      var keys = Object.keys(json);
      keys.forEach(function(key) {
        var arrObj = {};
        arrObj["name"] = key;
        for (var keyEle in json[key]) {
          arrObj[keyEle] = json[key][keyEle];
        }
        result.push(arrObj);
      });
      return result;
    },
    async getLocation() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.API_GATEWAY +
        `/location/userLocations?tenantName=${this.lastSelectedTenant}`;
      var get_Location = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(get_Location);
        if (response.status === 503) {
          return this.getLocation();
        }
        var getLoc = await response.json();
        getLoc = this.sortArrayByKey(getLoc, "name");
        this.buildTreeControlMapping(getLoc);
        this.allFacilitiesLength = this.locations && this.locations.length;
      } catch (error) {
        console.log(error);
      }
    },
    getAccessFlag(locationId, unitId, areaId) {
      if (this.selectedSamlGroup.locations && this.selectedSamlGroup.units && this.selectedSamlGroup.areas && this.selectedSamlGroup.areas.length > 0 && locationId && unitId && areaId) {
        return (
          this.selectedSamlGroup.locations.indexOf(locationId) > -1 &&
          this.selectedSamlGroup.units.indexOf(unitId) > -1 &&
          this.selectedSamlGroup.areas.indexOf(areaId) > -1
        );
      } else if (this.selectedSamlGroup.locations && this.selectedSamlGroup.units && this.selectedSamlGroup.units.length > 0 && locationId && unitId) {
        return (
          this.selectedSamlGroup.locations.indexOf(locationId) > -1 &&
          this.selectedSamlGroup.units.indexOf(unitId) > -1
        );
      } else if (this.selectedSamlGroup.locations && locationId) {
        return this.selectedSamlGroup.locations.indexOf(locationId) > -1;
      }
      return false;
    },
    getAlertFlag(locationId, unitId, areaId) {
      if (this.selectedSamlGroup.alerts && this.selectedSamlGroup.alerts.shift && this.selectedSamlGroup.alerts.shift.length > 0) {
        if (this.selectedSamlGroup.alerts.shift.find((s) => s.location === locationId && s.unit === unitId && s.area === areaId)) return true;
        if (this.selectedSamlGroup.alerts.shift.find((s) => s.location === locationId && s.unit === "*" && s.area === "*")) return true;
      }
      return false;
    },
    buildTreeControlMapping(locations) {
      if (locations && locations.length > 0) {
        locations.forEach((location) => {
          let locationChildren = {
            locationId: location.locationId,
            uniqueId: location.locationId,
            name: location.name,
            level: "LOCATION",
            children: [],
            roomCount: 0,
            roomAccessCount: 0,
            roomAlertCount: 0
          };
          if (location.activeFeatures && location.activeFeatures.length > 0) {
            location.activeFeatures.forEach((activeFeature) => {
              let activeFeatureChild = {
                id: activeFeature.id + "_" + location.locationId,
                uniqueId: location.locationId,
                locationId: location.locationId,
                name: activeFeature.name,
                type: activeFeature.type,
                level: "ACTIVEFEATURE",
                typeFilter: activeFeature.typeFilter,
                children: [],
                access: false,
                alert: false
              };
              if (location.units && location.units.length > 0) {
                location.units.forEach((unit) => {
                  let unitChild = {
                    id: activeFeature.id + "_" + unit.id,
                    uniqueId: unit.id,
                    locationId: location.locationId,
                    unitId: unit.id,
                    name: unit.name,
                    level: "UNIT",
                    children: [],
                    access: false,
                    alert: false
                  };
                  if (unit.areas && unit.areas.length > 0) {
                    let activeAreas = unit.areas.filter(
                      (a) => a.type === activeFeature.typeFilter
                    );
                    activeAreas = this.sortArrayByKey(activeAreas, "name");

                    activeAreas.forEach((area) => {
                      locationChildren.roomCount++;
                      const areaChild = {
                        id: area.id,
                        uniqueId: area.id,
                        locationId: location.locationId,
                        unitId: unit.id,
                        areaId: area.id,
                        name: area.name,
                        level: "AREA",
                        access: this.getAccessFlag(
                          location.locationId,
                          unit.id,
                          area.id
                        ),
                        alert: this.getAlertFlag(
                          location.locationId,
                          unit.id,
                          area.id
                        )
                      };
                      if (areaChild.access) locationChildren.roomAccessCount++;
                      if (areaChild.alert) locationChildren.roomAlertCount++;
                      unitChild.children.push(areaChild);
                    });
                  }
                  if (
                    unitChild &&
                    unitChild.children &&
                    unitChild.children.length > 0
                  )
                    activeFeatureChild.children.push(unitChild);
                });
              }
              if (
                activeFeatureChild &&
                activeFeatureChild.children &&
                activeFeatureChild.children.length > 0
              )
                locationChildren.children.push(activeFeatureChild);
            });
          }
          if (
            locationChildren &&
            locationChildren.children &&
            locationChildren.children.length > 0
          )
            this.locations.push(locationChildren);
        });
      }
    },
    sortArrayByKey(array, key) {
      if (array && array.length > 0) {
        return array.sort((a, b) => {
          try {
            const x = a[key].toLowerCase();
            const y = b[key].toLowerCase();
            return x < y ? -1 : x > y ? 1 : 0;
          } catch (err) {
          }
          return -1;
        });
      } else {
        return array;
      }
    },
    toggleNode(node) {
      this.node.isExpanded = !this.node.isExpanded;
    },
    onSelectedRow(selectedLocation) {
      this.selectedFacility = selectedLocation;
    },
    facilityAccessClicked($event, selectedLocation) {
      this.selectedFacility = selectedLocation;
      this.selectedSamlGroup.locations = this.mergeArrayAttributes(
        this.selectedSamlGroup.locations,
        selectedLocation.locationId,
        $event.target.checked
      );
    },
    mergeArrayAttributes(list, value, addOrRemove) {
      if (!list || !Array.isArray(list)) list = [];
      if (addOrRemove) {
        if (list.indexOf(value) === -1) list.push(value);
      } else {
        var i = 0;
        while (i < list.length) {
          if (list[i] === value) {
            list.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
      return list;
    },
    setContextIdsBySelection(dataType, nodeType, uniqueId) {
      if (!this.selectedSamlGroup[`${dataType}-${nodeType}`]) this.selectedSamlGroup[`${dataType}-${nodeType}`] = [];

      if (this.selectedSamlGroup[`${dataType}-${nodeType}`].indexOf(uniqueId) === -1) this.selectedSamlGroup[`${dataType}-${nodeType}`].push(uniqueId);
    },
    async saveSAMLGroupMapping() {
      const aYearFromNow = new Date();
      aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 2);
      let alertShifts = {
        alert: {
          shift: []
        }
      };

      let accessCountMatches = true;
      let alertCountMatches = true;

      this.locations.forEach((l) => {
        if (accessCountMatches && l.roomAccessCount > 0 && l.roomCount !== l.roomAccessCount) {
          accessCountMatches = false;
        }
        if (alertCountMatches && l.roomAlertCount > 0 && l.roomCount !== l.roomAlertCount) {
          alertCountMatches = false;
        }
      });
      this.locations.forEach((l) => {
        if (l.children && l.children.length > 0) {
          l.children.forEach((lActiveFeature) => {
            if (lActiveFeature.children && lActiveFeature.children.length > 0) {
              lActiveFeature.children.forEach((u) => {
                if (u.children && u.children.length > 0) {
                  u.children.forEach((a) => {
                    if (a && a.access === true) {
                      this.setContextIdsBySelection("access", "locations", a.locationId);
                      this.setContextIdsBySelection("access", "units", a.unitId);
                      this.setContextIdsBySelection("access", "areas", a.areaId);
                    }
                    if (a && a.alert === true) {
                      if (alertCountMatches === true) {
                        if (!alertShifts.alert.shift.find(s => s.location === a.locationId)) {
                          alertShifts.alert.shift.push({
                            location: a.locationId,
                            unit: "*",
                            area: "*",
                            start: new Date(),
                            end: aYearFromNow
                          });
                        }
                      } else {
                        if (!alertShifts.alert.shift.find(s => s.location === a.locationId && s.unit === a.unitId && s.area === a.areaId)) {
                          alertShifts.alert.shift.push({
                            location: a.locationId,
                            unit: a.unitId,
                            area: a.areaId,
                            start: new Date(),
                            end: aYearFromNow
                          });
                        }
                      }
                    }
                  });
                }
              });
            }
          });
        }
      });

      let accessLocationIds = [];
      let accessUnitIds = [];
      let accessAreaIds = [];

      if (accessCountMatches) {
        accessLocationIds = this.selectedSamlGroup["access-locations"];
      } else {
        accessLocationIds = this.selectedSamlGroup["access-locations"];
        accessUnitIds = this.selectedSamlGroup["access-units"];
        accessAreaIds = this.selectedSamlGroup["access-areas"];
      }

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/saml-groups`;
      var fetch_Roles = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify({
          _id: this.selectedSamlGroup._id,
          tenant: this.lastSelectedTenant,
          roles: this.selectedSamlGroup.roles,
          name: this.selectedSamlGroup.name.trim(),
          description: this.selectedSamlGroup.description,
          locations:
            accessLocationIds && accessLocationIds.length > 0
              ? accessLocationIds
              : undefined,
          units:
            accessUnitIds && accessUnitIds.length > 0
              ? accessUnitIds
              : undefined,
          areas:
            accessAreaIds && accessAreaIds.length > 0
              ? accessAreaIds
              : undefined,
          alerts: alertShifts.alert,
          pref_vn_fltr: this.selectedSamlGroup.pref_vn_fltr
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(fetch_Roles);
        if (response.status === 503) {
          return this.saveSAMLGroupMapping();
        }
        var saml_grp_response = await response.json();
        this.$emit("closeEvent");
        Vue.$toast.open({
          message: "Saml-group add/update successful.",
          type: "success"
        });
      } catch (err) {
        console.error("Faciled to save SAML Grp Mapping", err);
        Vue.$toast.open({
          message: "Saml-group add/update failed.",
          type: "error"
        });
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.tree-view {
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.node {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px 8px;
}

.node:hover {
  background-color: #f0f0f0;
}

.node i {
  margin-right: 8px;
}

.file {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  color: #888;
}

.file:hover {
  background-color: #f0f0f0;
}

.file i {
  margin-right: 8px;
}

.buttonItem {
  border: 1px solid #1dd8f6;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 0px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  background: #1dd8f6;
}


</style>
<style scoped>

#modal-2 .modal-footer {
  display: none !important;
}</style>
